import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
import { Link } from 'react-router-dom';
export function TermsPage() {
  const sections = [{
    id: 'acceptance',
    title: 'Acceptance of Terms'
  }, {
    id: 'eligibility',
    title: 'Eligibility'
  }, {
    id: 'accounts',
    title: 'Accounts'
  }, {
    id: 'description',
    title: 'Description of Pulsewave'
  }, {
    id: 'ai-outputs',
    title: 'AI Outputs and Recommendations'
  }, {
    id: 'responsibilities',
    title: 'Creator Responsibilities'
  }, {
    id: 'pulse-markets',
    title: 'Pulse Markets and Fan Validation'
  }, {
    id: 'points-reputation',
    title: 'Points, Reputation, and Value'
  }, {
    id: 'market-integrity',
    title: 'Market Integrity'
  }, {
    id: 'user-content',
    title: 'User Content'
  }, {
    id: 'ai-output-rights',
    title: 'AI Output Rights'
  }, {
    id: 'pulsewave-ip',
    title: 'Pulsewave IP'
  }, {
    id: 'third-party',
    title: 'Third-Party Platforms'
  }, {
    id: 'payments',
    title: 'Payments and Subscriptions'
  }, {
    id: 'creator-lab',
    title: 'Creator Lab and Beta Programs'
  }, {
    id: 'acceptable-use',
    title: 'Acceptable Use'
  }, {
    id: 'moderation',
    title: 'Moderation and Enforcement'
  }, {
    id: 'feedback',
    title: 'Feedback'
  }, {
    id: 'disclaimers',
    title: 'Disclaimers'
  }, {
    id: 'liability',
    title: 'Limitation of Liability'
  }, {
    id: 'indemnification',
    title: 'Indemnification'
  }, {
    id: 'termination',
    title: 'Termination'
  }, {
    id: 'governing-law',
    title: 'Governing Law and Disputes'
  }, {
    id: 'changes',
    title: 'Changes to Terms'
  }, {
    id: 'contact',
    title: 'Contact Us'
  }];
  return <LegalLayout title="Terms of Service" subtitle="The rules and guidelines for using Pulsewave." lastUpdated="06/01/26" sections={sections} data-id="element-323">
      <section id="acceptance" className="mb-12" data-id="element-324">
        <h2 data-id="element-325">Acceptance of Terms</h2>
        <p data-id="element-326">
          By accessing or using Pulsewave, you agree to be bound by these Terms
          of Service. If you do not agree to these terms, please do not use our
          services.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-327" />

      <section id="eligibility" className="mb-12" data-id="element-328">
        <h2 data-id="element-329">Eligibility</h2>
        <p data-id="element-330">
          You must be at least 13 years old to use Pulsewave. Users under 18
          require parent or guardian permission. Creator accounts should be used
          only by individuals who have the authority to represent the creator,
          brand, or business associated with the account.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-331" />

      <section id="accounts" className="mb-12" data-id="element-332">
        <h2 data-id="element-333">Accounts</h2>
        <p data-id="element-334">
          You are responsible for maintaining the security of your account and
          for all activities that occur under your account. We may support team
          members or authorized users, but the primary account holder remains
          responsible for their actions.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-335" />

      <section id="description" className="mb-12" data-id="element-336">
        <h2 data-id="element-337">Description of Pulsewave</h2>
        <p data-id="element-338">
          Pulsewave is an AI-powered creator strategist that helps creators
          discover, validate, and plan audience-backed business moves. We may
          analyze creator content, audience signals, connected platform data,
          creator-provided inputs, and fan participation to generate pitches,
          recommendations, markets, briefs, and insights.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-339" />

      <section id="ai-outputs" className="mb-12" data-id="element-340">
        <h2 data-id="element-341">AI Outputs and Recommendations</h2>
        <p data-id="element-342">
          Outputs from Pulsewave may include ideas, rankings, scores, summaries,
          validation questions, market structures, captions, launch briefs, and
          next-move recommendations.
        </p>
        <ul data-id="element-343">
          <li data-id="element-344">Outputs are informational and strategic suggestions only.</li>
          <li data-id="element-345">
            Pulsewave does not guarantee sales, audience growth, product-market
            fit, market accuracy, launch success, business outcomes, or that
            outputs are complete, accurate, unique, or suitable.
          </li>
          <li data-id="element-346">
            Creators are solely responsible for reviewing outputs before relying
            on, publishing, selling, launching, or acting on them.
          </li>
          <li data-id="element-347">
            Pulsewave does not provide legal, financial, tax, medical, or
            professional advice.
          </li>
        </ul>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-348" />

      <section id="responsibilities" className="mb-12" data-id="element-349">
        <h2 data-id="element-350">Creator Responsibilities</h2>
        <p data-id="element-351">As a creator using Pulsewave, you are responsible for:</p>
        <ul data-id="element-352">
          <li data-id="element-353">
            Your content, launches, products, services, offers, claims, pricing,
            fulfillment, customer support, refunds, taxes,
            advertising/endorsement compliance, privacy obligations, and overall
            legal compliance.
          </li>
          <li data-id="element-354">
            Ensuring you have the necessary rights to any content, data,
            platform accounts, or private materials you connect or upload to
            Pulsewave.
          </li>
          <li data-id="element-355">
            Ensuring your use of Pulsewave complies with the rules and terms of
            third-party platforms you integrate with.
          </li>
        </ul>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-356" />

      <section id="pulse-markets" className="mb-12" data-id="element-357">
        <h2 data-id="element-358">Pulse Markets and Fan Validation</h2>
        <p data-id="element-359">
          Pulse Markets are tools for audience research, validation, engagement,
          and signal generation. They are not guarantees of demand or success.
          While Pulsewave may provide suggested market structures, creators are
          entirely responsible for the markets they publish and how they
          interpret or use the results.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-360" />

      <section id="points-reputation" className="mb-12" data-id="element-361">
        <h2 data-id="element-362">Points, Reputation, and No Monetary Value</h2>
        <p data-id="element-363">
          Unless expressly stated in separate official rules, any points,
          conviction metrics, reputation scores, rankings, or similar mechanics
          within Pulsewave have no cash value. They cannot be purchased, sold,
          transferred, or redeemed, and they do not represent money, property,
          securities, financial instruments, gambling winnings, ownership, or
          enforceable rights.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-364" />

      <section id="market-integrity" className="mb-12" data-id="element-365">
        <h2 data-id="element-366">Market Integrity</h2>
        <p data-id="element-367">
          We prohibit the use of bots, fake accounts, vote manipulation, buying
          or selling participation, coordinated manipulation, harassment, spam,
          scraping, reverse engineering, interfering with scoring, or gaming
          market outcomes.
        </p>
        <p data-id="element-368">
          Pulsewave reserves the right to remove activity, adjust points, cancel
          markets, resolve markets, suspend users, or take other enforcement
          actions to protect the integrity of the platform.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-369" />

      <section id="user-content" className="mb-12" data-id="element-370">
        <h2 data-id="element-371">User Content</h2>
        <p data-id="element-372">
          You retain ownership of your content. By using Pulsewave, you grant us
          a license to host, process, analyze, transform, display, summarize,
          cite, and create insights from your content (including creator
          content, fan comments/takes, uploaded materials, connected data,
          market content, ideas, feedback, and other submissions) to operate,
          improve, secure, and promote the service where permitted.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-373" />

      <section id="ai-output-rights" className="mb-12" data-id="element-374">
        <h2 data-id="element-375">AI Output Rights</h2>
        <p data-id="element-376">
          As between Pulsewave and the creator, creators may use outputs
          generated specifically for their account for their own business
          purposes. However, Pulsewave does not guarantee that outputs are
          unique, protectable, non-infringing, or unavailable to others. Similar
          outputs may be generated for other users.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-377" />

      <section id="pulsewave-ip" className="mb-12" data-id="element-378">
        <h2 data-id="element-379">Pulsewave IP</h2>
        <p data-id="element-380">
          Pulsewave owns the platform, software, workflows, prompts, scoring
          systems, market mechanics, design, brand, models, documentation, and
          all related intellectual property.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-381" />

      <section id="third-party" className="mb-12" data-id="element-382">
        <h2 data-id="element-383">Third-Party Platforms and Services</h2>
        <p data-id="element-384">
          Pulsewave integrates with third-party platforms like YouTube/Google,
          Instagram/Meta, TikTok, and others. Pulsewave is not responsible for
          third-party platforms, API changes, outages, permissions, or their
          respective terms of service.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-385" />

      <section id="payments" className="mb-12" data-id="element-386">
        <h2 data-id="element-387">Payments, Subscriptions, and Beta Access</h2>
        <p data-id="element-388">
          Some features of Pulsewave may be free, paid, invite-only, beta, or
          subject to usage limits. Fees, billing terms, renewals, cancellation
          policies, and refunds will be disclosed at the time of purchase.
          Pulsewave reserves the right to modify or discontinue beta features at
          any time.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-389" />

      <section id="creator-lab" className="mb-12" data-id="element-390">
        <h2 data-id="element-391">Creator Lab and Beta Programs</h2>
        <p data-id="element-392">
          Pulsewave may offer beta programs, pilots, or creator labs subject to
          additional terms. Participants may be asked to provide feedback,
          participate in calls, test features, or approve case studies
          separately.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-393" />

      <section id="acceptable-use" className="mb-12" data-id="element-394">
        <h2 data-id="element-395">Acceptable Use</h2>
        <p data-id="element-396">
          You agree not to use Pulsewave for illegal, harmful, infringing,
          deceptive, hateful, harassing, sexually exploitative,
          privacy-invasive, spammy, malicious, or abusive purposes.
        </p>
        <p data-id="element-397">
          Additionally, you may not use Pulsewave for regulated or high-risk
          categories without explicit permission, including gambling, financial
          products, medical/health claims, alcohol, weapons, adult products,
          political persuasion, kids-directed campaigns, and other sensitive
          categories.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-398" />

      <section id="moderation" className="mb-12" data-id="element-399">
        <h2 data-id="element-400">Moderation and Enforcement</h2>
        <p data-id="element-401">
          Pulsewave reserves the right to remove content, restrict features,
          suspend accounts, terminate access, investigate abuse, or cooperate
          with legal authorities at our discretion.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-402" />

      <section id="feedback" className="mb-12" data-id="element-403">
        <h2 data-id="element-404">Feedback</h2>
        <p data-id="element-405">
          We welcome your feedback. Pulsewave may use suggestions, feedback, or
          ideas you provide without any obligation or compensation to you.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-406" />

      <section id="disclaimers" className="mb-12" data-id="element-407">
        <h2 data-id="element-408">Disclaimers</h2>
        <p data-id="element-409">
          The service is provided "as is" and "as available," without warranties
          of any kind, either express or implied.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-410" />

      <section id="liability" className="mb-12" data-id="element-411">
        <h2 data-id="element-412">Limitation of Liability</h2>
        <p data-id="element-413">
          To the maximum extent allowed by law, Pulsewave's liability is limited
          to the amount paid by the user to Pulsewave in the prior 12 months or
          $100, whichever is greater.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-414" />

      <section id="indemnification" className="mb-12" data-id="element-415">
        <h2 data-id="element-416">Indemnification</h2>
        <p data-id="element-417">
          Users, especially creators, agree to indemnify and hold harmless
          Pulsewave for claims related to their content, launches, products,
          services, market setup, fan communications, legal violations,
          infringement, or misuse of the service.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-418" />

      <section id="termination" className="mb-12" data-id="element-419">
        <h2 data-id="element-420">Termination</h2>
        <p data-id="element-421">
          You may stop using the service at any time. Pulsewave may suspend or
          terminate your access for violations of these Terms or if your use
          poses a risk to the platform or other users.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-422" />

      <section id="governing-law" className="mb-12" data-id="element-423">
        <h2 data-id="element-424">Governing Law and Disputes</h2>
        <p data-id="element-425">
          These Terms are governed by applicable law, without regard to
          conflict-of-law rules. Dispute resolution details to be finalized by
          counsel.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-426" />

      <section id="changes" className="mb-12" data-id="element-427">
        <h2 data-id="element-428">Changes to Terms</h2>
        <p data-id="element-429">
          Pulsewave may update these Terms from time to time. We will notify you
          of any changes by posting the new Terms on this page and updating the
          "Last updated" date.
        </p>
      </section>

      <div className="w-full h-px bg-white/5 my-12" data-id="element-430" />

      <section id="contact" className="mb-12" data-id="element-431">
        <h2 data-id="element-432">Contact Us</h2>
        <p data-id="element-433">
          If you have any questions about these Terms, please contact us at:
        </p>
        <p data-id="element-434">
          <strong data-id="element-435">Foundation Lab, LLC</strong>
          <br data-id="element-436" />
          Email: support@pulsewaveco.com
        </p>
      </section>
    </LegalLayout>;
}